import React, { useState } from 'react';

export default function TagsInput({
    label,
    value = [],
    onChange,
    placeholder = 'Add tag and press Enter',
    helpText,
}) {
    const [draft, setDraft] = useState('');
    const tags = Array.isArray(value) ? value : [];

    const addTag = () => {
        const v = draft.trim().toLowerCase();
        if (!v) return;
        if (tags.includes(v)) {
            setDraft('');
            return;
        }
        onChange([...tags, v]);
        setDraft('');
    };

    const removeTag = (t) => {
        onChange(tags.filter((x) => x !== t));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag();
        } else if (e.key === 'Backspace' && !draft && tags.length) {
            removeTag(tags[tags.length - 1]);
        }
    };

    return (
        <div className="space-y-1">
            {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
            <div className="flex flex-wrap gap-1.5 rounded-md border border-gray-300 bg-white px-2 py-1.5 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
                {tags.map((t) => (
                    <span
                        key={t}
                        className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700"
                    >
                        #{t}
                        <button
                            type="button"
                            onClick={() => removeTag(t)}
                            className="text-blue-500 hover:text-blue-800"
                            aria-label={`Remove ${t}`}
                        >
                            ×
                        </button>
                    </span>
                ))}
                <input
                    type="text"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={addTag}
                    placeholder={tags.length ? '' : placeholder}
                    className="flex-1 min-w-[120px] border-0 p-0 text-sm focus:ring-0 focus:outline-none"
                />
            </div>
            {helpText && <p className="text-xs text-gray-500">{helpText}</p>}
        </div>
    );
}
